import { createSlice } from "@reduxjs/toolkit";
export const adminNotificationSlice = createSlice({
  name: "adminNotificationSlice",
  initialState: {
    adminNotificationCount: 0,
    notificationFilter: {},
    LogHistoryFilters: {},
  },
  reducers: {
    setAdminNotificationCount: (state, action) => {
      return { ...state, adminNotificationCount: action.payload };
    },
    setNotificationFilter: (state, action) => {
      return { ...state, notificationFilter: action.payload };
    },
    setLogHistoryFilter: (state, action) => {
      return { ...state, LogHistoryFilters: action.payload };
    },
    ResetNotificationFilter: (state) => {
      return { ...state, notificationFilter: {}, LogHistoryFilters: {} }
    }
  },
});

export const { setAdminNotificationCount, setNotificationFilter, setLogHistoryFilter, ResetNotificationFilter } =
  adminNotificationSlice.actions;

export default adminNotificationSlice.reducer;
